"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AllGood;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AllGood(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "108",
    height: "108",
    viewBox: "0 0 108 108",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "54",
    cy: "54",
    r: "54",
    fill: "#327320"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.6878 39.24C59.2003 38.3228 59.4721 37.2907 59.4778 36.24C59.4791 35.421 59.319 34.6098 59.0065 33.8528C58.694 33.0958 58.2353 32.4078 57.6566 31.8283C57.078 31.2487 56.3908 30.7889 55.6342 30.4752C54.8777 30.1615 54.0668 30 53.2478 30C51.5929 30 50.0057 30.6574 48.8355 31.8277C47.6652 32.9979 47.0078 34.5851 47.0078 36.24C47.0082 37.2661 47.2624 38.276 47.7478 39.18C49.4745 38.8766 51.2246 38.7261 52.9778 38.73C54.8932 38.7147 56.8055 38.8855 58.6878 39.24V39.24Z",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.7516 50.44C40.7529 50.7293 40.6969 51.016 40.5868 51.2835C40.4767 51.551 40.3147 51.7941 40.1102 51.9986C39.9056 52.2032 39.6625 52.3652 39.395 52.4753C39.1275 52.5854 38.8408 52.6414 38.5516 52.64C37.9681 52.64 37.4085 52.4082 36.9959 51.9957C36.5833 51.5831 36.3516 51.0235 36.3516 50.44C36.3542 49.8583 36.5872 49.3013 36.9995 48.8909C37.4117 48.4804 37.9698 48.25 38.5516 48.25C38.84 48.2487 39.1259 48.3044 39.3927 48.4138C39.6596 48.5233 39.9022 48.6844 40.1066 48.8879C40.311 49.0914 40.4732 49.3333 40.5839 49.5996C40.6946 49.866 40.7516 50.1516 40.7516 50.44V50.44Z",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.84 36.32H46.66C44.0751 36.889 41.586 37.8288 39.27 39.11V39.11C35.73 36.47 31.58 35.5901 28.37 36.4901C28 39.4401 29.37 42.87 32.02 45.63C31.3197 46.6552 30.7361 47.7553 30.28 48.91H23C23 55.03 26.51 60.2501 31.42 62.2401C33.0745 64.9828 35.3573 67.2929 38.08 68.98L37.36 75.06C37.3289 75.3406 37.3576 75.6245 37.4441 75.8931C37.5306 76.1618 37.673 76.4091 37.8619 76.6187C38.0508 76.8284 38.282 76.9958 38.5402 77.1097C38.7984 77.2237 39.0778 77.2818 39.36 77.28H44.97C45.3822 77.2791 45.7841 77.1509 46.1206 76.9128C46.4572 76.6747 46.7119 76.3385 46.85 75.95L47.96 72.74C49.6908 73.0382 51.4438 73.1887 53.2 73.19C55.0755 73.1918 56.947 73.0177 58.79 72.67L59.92 75.95C60.0581 76.3385 60.3128 76.6747 60.6494 76.9128C60.9859 77.1509 61.3878 77.2791 61.8 77.28H67.41C67.6922 77.2818 67.9716 77.2237 68.2298 77.1097C68.488 76.9958 68.7192 76.8284 68.9081 76.6187C69.097 76.4091 69.2394 76.1618 69.3259 75.8931C69.4124 75.6245 69.4411 75.3406 69.41 75.06L68.66 68.76",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M74.6765 62.7002C76.2439 60.2403 77.0829 57.3869 77.0966 54.4702C77.0966 45.9602 69.8766 38.7702 59.9866 36.4702L59.7266 36.4102",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M76.8398 51.6879C80.6698 50.2479 81.8399 48.6879 82.1399 46.4779C82.4299 44.6679 81.7298 42.0379 79.8098 41.3779C79.4205 41.2399 78.9989 41.2204 78.5984 41.3218C78.198 41.4233 77.8366 41.6411 77.5598 41.9479C76.8098 42.8779 77.1098 44.3479 77.5598 45.3579C78.3498 47.2879 80.6098 49.1579 82.8098 48.5479C83.5409 48.3491 84.1788 47.8996 84.6121 47.2781C85.0453 46.6566 85.2463 45.9026 85.1798 45.1479",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.4003 39.6193C57.9754 39.0024 55.4825 38.6934 52.9803 38.6993C50.6541 38.6932 48.3351 38.9584 46.0703 39.4893",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.6878 39.24C59.2003 38.3228 59.4721 37.2907 59.4778 36.24C59.4791 35.421 59.319 34.6098 59.0065 33.8528C58.694 33.0958 58.2353 32.4078 57.6566 31.8283C57.078 31.2487 56.3908 30.7889 55.6342 30.4752C54.8777 30.1615 54.0668 30 53.2478 30C51.5929 30 50.0057 30.6574 48.8355 31.8277C47.6652 32.9979 47.0078 34.5851 47.0078 36.24C47.0082 37.2661 47.2624 38.276 47.7478 39.18C49.4745 38.8766 51.2246 38.7261 52.9778 38.73C54.8941 38.7246 56.8065 38.9054 58.6878 39.27",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M77.9916 62.2375C77.9906 62.7203 77.8837 63.1969 77.6784 63.6339C77.4731 64.0708 77.1745 64.4574 76.8036 64.7663C76.4326 65.0753 75.9984 65.2991 75.5316 65.422C75.0647 65.5449 74.5766 65.5638 74.1016 65.4775C73.4438 65.3554 72.8385 65.0367 72.3654 64.5637C71.8924 64.0906 71.5738 63.4853 71.4516 62.8275C71.3653 62.3525 71.3842 61.8644 71.5071 61.3976C71.63 60.9307 71.8538 60.4965 72.1628 60.1255C72.4717 59.7546 72.8583 59.4559 73.2952 59.2507C73.7322 59.0454 74.2088 58.9385 74.6916 58.9375C75.5668 58.9375 76.4062 59.2852 77.0251 59.9041C77.6439 60.5229 77.9916 61.3623 77.9916 62.2375Z",
    fill: "#54C8E8"
  }));
}